import React, { FC } from 'react';

import { Container, Typography } from '@mui/material';
import cx from 'classnames';

import { Background, Maybe, Scalars, WhatBusinessStand } from '../../types';
import useTextStyles from '../../utils/textStyles';
import Card from './Card';
import useStyles from './styles';

export type CardType = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
};

interface CardsBlockProps {
  data: WhatBusinessStand;
}

const CardsBlock: FC<CardsBlockProps> = ({ data }) => {
  const { background, section_first, section_second } = data;

  const classes = useStyles(background)();
  const textClasses = useTextStyles();

  return (
    <div
      className={cx(classes.wrapper, background === Background.Dark ? 'dark-block' : 'light-block')}
    >
      <Container className={classes.container}>
        {section_first?.title && (
          <Typography variant="h2" align="center" className={cx(textClasses.h2, classes.heading)}>
            {section_first?.title}
          </Typography>
        )}
        {section_first?.description && (
          <Typography align="center" className={cx(textClasses.body, classes.description)}>
            {section_first?.description}
          </Typography>
        )}
        {section_second?.title && (
          <Typography variant="h3" align="center" className={cx(textClasses.h3, classes.title)}>
            {section_second?.title}
          </Typography>
        )}
        {section_second?.usp_icon_block && section_second.usp_icon_block.length > 0 && (
          <div className={classes.cardsWrapper}>
            {section_second.usp_icon_block.map((item) => (
              <div key={item?.usp_icon_image} className={classes.cardWrapper}>
                <Card
                  title={item?.usp_title}
                  description={item?.usp_description}
                  imageUrl={item?.usp_icon_image}
                  background={background}
                  wrapperClass={classes.card}
                />
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default CardsBlock;
